export enum PaymentType {
  BALANCE = "BALANCE",
  BANK_TRANSFER = "BANK_TRANSFER",
  CASH = "CASH",
  CHECK = "CHECK",
  OTHER = "OTHER",
  SQUARE_LEGACY = "SQUARE_LEGACY",
  STRIPE = "STRIPE",
}
